import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { TimeBucketFilterComponent } from './components/time-bucket-filter/time-bucket-filter.component';
import { SharedModule } from '../../../../shared/shared.module';
import { ComponentsModule } from '../../../../shared/components/components.module';

@NgModule({
  declarations: [
    TimeBucketFilterComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule,
    SharedModule,
    ComponentsModule
  ],
  exports: [
    TimeBucketFilterComponent
  ]
})
export class OtpSharedModule {}